// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1GCIh","unreadBadge":"styles_unreadBadge__2eZjR","modalContent":"styles_modalContent__3khUh","modal":"styles_modal__1Pq67"};